import { ModuleWithProviders, NgModule, inject } from '@angular/core';
import {SkipLinkComponent} from './components/skip-link/skip-link.component';
import {AccessibilityService} from './services/accessibility.service';
import {FocusBlockDirective} from './directives/focus-block.directive';
import {FocusTrapDirective} from './directives/focus-trap.directive';
import {HotkeyConfirmDirective} from './directives/hotkey-confirm.directive';
import {HotkeyCreateDirective} from './directives/hotkey-create.directive';
import {HotkeyDeleteDirective} from './directives/hotkey-delete.directive';
import {HotkeyFocusSearchDirective} from './directives/hotkey-focus-search.directive';
import {KeyboardClickableDirective} from './directives/keyboard-clickable.directive';
import {PageTitleLevelDirective} from './directives/page-title-level.directive';
import {
    provideNgxWebstorage,
    withLocalStorage,
    withNgxWebstorageConfig,
    withSessionStorage
} from 'ngx-webstorage';
import {FormFieldMessageDirective} from './directives/form-field-message';
import {TablistControlsDirective} from './directives/tablist-controls.directive';
import {AutoFocusDirective} from './directives/auto-focus.directive';

@NgModule({
    declarations: [
        SkipLinkComponent,
        FocusBlockDirective,
        FocusTrapDirective,
        HotkeyConfirmDirective,
        HotkeyCreateDirective,
        HotkeyDeleteDirective,
        HotkeyFocusSearchDirective,
        KeyboardClickableDirective,
        AutoFocusDirective,
        PageTitleLevelDirective,
        TablistControlsDirective,
        FormFieldMessageDirective
    ],
    providers: [
        AccessibilityService,
        provideNgxWebstorage(
            withNgxWebstorageConfig({ prefix: 'UI-ACCESSIBILITY', separator: '_', caseSensitive: true }),
            withLocalStorage(),
            withSessionStorage()
        )
    ],
    imports: [],
    exports: [
        SkipLinkComponent,
        FocusBlockDirective,
        FocusTrapDirective,
        HotkeyConfirmDirective,
        HotkeyCreateDirective,
        HotkeyDeleteDirective,
        HotkeyFocusSearchDirective,
        KeyboardClickableDirective,
        AutoFocusDirective,
        PageTitleLevelDirective,
        TablistControlsDirective,
        FormFieldMessageDirective
    ]
})
export class UiAccessibilityModule {
    private accessibilityService = inject(AccessibilityService);

    static WhitelistedRoutes = [];

    constructor() {
        this.accessibilityService.init(UiAccessibilityModule.WhitelistedRoutes);
    }

    static forRoot(whitelistedRoutes: string[] = []): ModuleWithProviders<UiAccessibilityModule> {
        UiAccessibilityModule.WhitelistedRoutes = whitelistedRoutes;

        return {
            ngModule: UiAccessibilityModule,
            providers: [
                AccessibilityService
            ]
        };
    }
}
